import { Action } from 'redux'
import { put, takeLatest, all } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/companies/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.cities.list

// This saga is for getting list of companies
function* listSagaTask({ payload }: TaskAction) {
    const pagination = {
        limit: 1000,
        ...payload.pagination
    }
    try {
        const params = {
            ...pagination,
            query: payload.query
        }

        const response = yield axios.get(`/companies/cities`, {
            params,
            transformRequest: (data, headers) => {
                delete headers['event-id']
                return data
            }
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result.data)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

const {
    onRequest: onRequestUpdate,
    onSuccess: onSuccessUpdate,
    onFailure: onFailureUpdate
} = rootActions.cities.listUpdate

// This saga is for getting list of companies
function* listUpdateSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query
        }

        const response = yield axios.get(`/companies/cities`, {
            params
        })
        if (response.success) {
            yield put(onSuccessUpdate(response.result))
        }
    } catch (error) {
        yield put(onFailureUpdate(error))
    }
}

function* listSaga(): any {
    yield all([
        takeLatest<TaskAction>(onRequest, listSagaTask),
        takeLatest<TaskAction>(onRequestUpdate, listUpdateSagaTask)
    ])
}

export default listSaga
